const setImageCarouselSticky = () => {
  const imageCarousel = document.querySelector('.product-details-carousel');
  window.experimentation.setImageCarouselStickyCalled = true;

  if (imageCarousel) {
    if (!imageCarousel.classList.contains('is-sticky')) {
      imageCarousel.classList.add('is-sticky');
      imageCarousel.setAttribute('data-controller', 'follow-element');
    }

    return true;
  }

  return false;
};

// With exception of above function (which has to remain a top-level function until the experiment is over),
// this top-level window object is where experimentation state and functions are located.
window.experimentation = {
  setImageCarouselStickyCalled: false,
  setImageCarouselSticky
};
